export default {
  files: 'files',
  user: {
    loggedInUser: 'loggedInUser',
    saveUser: 'saveUser',
  },
};
